import React from "react";
import { Link } from "react-router-dom";
import PageTitle from "./include/PageTitle";
import { useI18n } from "../i18n/I18nContext";
import { getServiceDetailsCopy, getSidebarLinks } from "../content/localeCopy";
import LocalizedLeadParagraph from "../Components/LocalizedLeadParagraph";
import { useTranslatedCopy } from "../i18n/useTranslatedCopy";
import ServiceInquiryForm from "../Components/ServiceInquiryForm";
import Seo, { ARABIC_SEO_KEYWORDS, ENGLISH_SEO_KEYWORDS, buildServiceStructuredData } from "../Components/Seo";

const maintenancePageImages = [
  "/img/service/maintenance-service-1.png",
  "/img/service/property-management-service-2.png",
  "/img/service/maintenance-service-3.png",
];

const maintenanceSidebarImage = "/img/service/maintenance-service-4.png";

const imageCardStyle = {
  background: "#ffffff",
  border: "1px solid rgba(187, 165, 92, 0.14)",
  borderRadius: "22px",
  overflow: "hidden",
  boxShadow: "0 16px 38px rgba(15, 23, 42, 0.08)",
  height: "100%",
};

const MaintenanceAndOperation = () => {
  const { locale } = useI18n();
  const copy = useTranslatedCopy(getServiceDetailsCopy("maintenance"), locale);
  const sidebar = useTranslatedCopy(getSidebarLinks(), locale);
  const matrixHeaderService = useTranslatedCopy("Service", locale);
  const matrixHeaderDetails = useTranslatedCopy("Details", locale);
  const galleryCaptionOne = useTranslatedCopy("Technical inspections and system upkeep", locale);
  const galleryCaptionTwo = useTranslatedCopy("Operational continuity and on-site support", locale);
  const maintenanceGalleryTitle = useTranslatedCopy("How we protect performance and reduce long-term cost", locale);
  const maintenanceGalleryText = useTranslatedCopy(
    "Our maintenance and operations approach combines planned inspections, rapid intervention and practical service coordination to keep facilities stable, safe and cost-efficient over time.",
    locale
  );
  const servicesHeading = useTranslatedCopy("Scope of Our Technical Services", locale);
  const methodologyHeading = useTranslatedCopy("Work Methodology: Preventative Maintenance", locale);

  const methodologyCards = [
    {
      title: useTranslatedCopy("Scheduled Visits", locale),
      body: useTranslatedCopy(
        "A comprehensive technical inspection of all property facilities conducted on a monthly or quarterly basis.",
        locale
      ),
    },
    {
      title: useTranslatedCopy("Condition Reports", locale),
      body: useTranslatedCopy(
        "Providing the owner with a technical report detailing the property's current condition and necessary recommendations.",
        locale
      ),
    },
    {
      title: useTranslatedCopy("Contract Management", locale),
      body: useTranslatedCopy(
        "Organizing and managing relationships with warranty providers and external vendors.",
        locale
      ),
    },
  ];

  return (
    <div>
      <Seo
        title="Property Maintenance & Operations | QTECH"
        titleAr="ØµÙŠØ§Ù†Ø© Ù…Ø¨Ø§Ù†ÙŠ ÙˆØ¹Ù‚Ø§Ø±Ø§Øª ÙÙŠ Ø§Ù„Ø®Ø¨Ø± ÙˆØ§Ù„Ø¯Ù…Ø§Ù… | Ø´Ø±ÙƒØ© ØªÙ‚Ù†ÙŠØ§Øª Ø§Ù„Ø¬ÙˆØ¯Ø©"
        description="QTECH provides property maintenance and operations services in Saudi Arabia, including preventive maintenance, emergency response, inspections, service coordination, and facility support."
        descriptionAr="ØªÙˆÙØ± Ø´Ø±ÙƒØ© ØªÙ‚Ù†ÙŠØ§Øª Ø§Ù„Ø¬ÙˆØ¯Ø© Ø®Ø¯Ù…Ø§Øª ØµÙŠØ§Ù†Ø© Ù…Ø¨Ø§Ù†ÙŠ ÙˆØµÙŠØ§Ù†Ø© Ø¹Ù‚Ø§Ø±Ø§Øª ÙÙŠ Ø§Ù„Ø®Ø¨Ø± ÙˆØ§Ù„Ø¯Ù…Ø§Ù… ØªØ´Ù…Ù„ ØµÙŠØ§Ù†Ø© Ø´Ø§Ù…Ù„Ø©ØŒ Ø³Ø¨Ø§ÙƒØ©ØŒ Ø£Ø¹Ù…Ø§Ù„ ÙƒÙ‡Ø±Ø¨Ø§Ø¡ØŒ ØªÙˆÙÙŠØ± ÙÙ†ÙŠÙŠÙ†ØŒ Ø£Ù†Ø¸Ù…Ø© Ø£Ù…Ù†ØŒ Ù…Ø±Ø§Ù‚Ø¨Ø©ØŒ ÙˆØªØ±ÙƒÙŠØ¨ ÙƒØ§Ù…ÙŠØ±Ø§Øª."
        keywords={ENGLISH_SEO_KEYWORDS.maintenance}
        keywordsAr={ARABIC_SEO_KEYWORDS.maintenance}
        path="/property-maintenance-operations-saudi-arabia"
        image={maintenancePageImages[0]}
        structuredData={buildServiceStructuredData({
          name: "Property Maintenance & Operations | QTECH",
          nameAr: "Ã˜ÂµÃ™Å Ã˜Â§Ã™â€ Ã˜Â© Ã™â€¦Ã˜Â¨Ã˜Â§Ã™â€ Ã™Å  Ã™Ë†Ã˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã˜Â§Ã˜Âª Ã™ÂÃ™Å  Ã˜Â§Ã™â€žÃ˜Â®Ã˜Â¨Ã˜Â± Ã™Ë†Ã˜Â§Ã™â€žÃ˜Â¯Ã™â€¦Ã˜Â§Ã™â€¦ | Ã˜Â´Ã˜Â±Ã™Æ’Ã˜Â© Ã˜ÂªÃ™â€šÃ™â€ Ã™Å Ã˜Â§Ã˜Âª Ã˜Â§Ã™â€žÃ˜Â¬Ã™Ë†Ã˜Â¯Ã˜Â©",
          description:
            "QTECH provides property maintenance and operations services in Saudi Arabia, including preventive maintenance, emergency response, inspections, service coordination, and facility support.",
          descriptionAr:
            "Ã˜ÂªÃ™Ë†Ã™ÂÃ˜Â± Ã˜Â´Ã˜Â±Ã™Æ’Ã˜Â© Ã˜ÂªÃ™â€šÃ™â€ Ã™Å Ã˜Â§Ã˜Âª Ã˜Â§Ã™â€žÃ˜Â¬Ã™Ë†Ã˜Â¯Ã˜Â© Ã˜Â®Ã˜Â¯Ã™â€¦Ã˜Â§Ã˜Âª Ã˜ÂµÃ™Å Ã˜Â§Ã™â€ Ã˜Â© Ã™â€¦Ã˜Â¨Ã˜Â§Ã™â€ Ã™Å  Ã™Ë†Ã˜ÂµÃ™Å Ã˜Â§Ã™â€ Ã˜Â© Ã˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã˜Â§Ã˜Âª Ã™ÂÃ™Å  Ã˜Â§Ã™â€žÃ˜Â®Ã˜Â¨Ã˜Â± Ã™Ë†Ã˜Â§Ã™â€žÃ˜Â¯Ã™â€¦Ã˜Â§Ã™â€¦ Ã˜ÂªÃ˜Â´Ã™â€¦Ã™â€ž Ã˜ÂµÃ™Å Ã˜Â§Ã™â€ Ã˜Â© Ã˜Â´Ã˜Â§Ã™â€¦Ã™â€žÃ˜Â©Ã˜Å’ Ã˜Â³Ã˜Â¨Ã˜Â§Ã™Æ’Ã˜Â©Ã˜Å’ Ã˜Â£Ã˜Â¹Ã™â€¦Ã˜Â§Ã™â€ž Ã™Æ’Ã™â€¡Ã˜Â±Ã˜Â¨Ã˜Â§Ã˜Â¡Ã˜Å’ Ã˜ÂªÃ™Ë†Ã™ÂÃ™Å Ã˜Â± Ã™ÂÃ™â€ Ã™Å Ã™Å Ã™â€ Ã˜Å’ Ã˜Â£Ã™â€ Ã˜Â¸Ã™â€¦Ã˜Â© Ã˜Â£Ã™â€¦Ã™â€ Ã˜Å’ Ã™â€¦Ã˜Â±Ã˜Â§Ã™â€šÃ˜Â¨Ã˜Â©Ã˜Å’ Ã™Ë†Ã˜ÂªÃ˜Â±Ã™Æ’Ã™Å Ã˜Â¨ Ã™Æ’Ã˜Â§Ã™â€¦Ã™Å Ã˜Â±Ã˜Â§Ã˜Âª.",
          path: "/property-maintenance-operations-saudi-arabia",
          image: maintenancePageImages[0],
          serviceType: "Property Maintenance and Operations",
        })}
      />

      <PageTitle
        title={copy.title}
        currentPage={copy.title}
        bgImage="/img/bg/14.jpg"
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <div className="ltn__blog-img">
                  <img
                    src={maintenancePageImages[0]}
                    alt={copy.imageLabel}
                    style={{ width: "100%", minHeight: "460px", objectFit: "cover" }}
                  />
                </div>

                <h2 className="title-2">{copy.imageLabel}</h2>

                {copy.paragraphs.map((text, index) => (
                  <LocalizedLeadParagraph
                    key={index}
                    text={text}
                    index={index}
                    locale={locale}
                  />
                ))}

                {Array.isArray(copy.highlights) && copy.highlights.length > 0 ? (
                  <div className="qtech-service-highlight-list">
                    {copy.highlights.map((item, index) => (
                      <div className="qtech-service-highlight-card" key={item.title || index}>
                        <h5>{item.title}</h5>
                        <p>{item.body}</p>
                      </div>
                    ))}
                  </div>
                ) : null}

                <div
                  style={{
                    marginTop: "34px",
                    marginBottom: "18px",
                    padding: "0 2px",
                  }}
                >
                  <h4
                    className="title-2"
                    style={{
                      marginBottom: "10px",
                    }}
                  >
                    {maintenanceGalleryTitle}
                  </h4>
                  <p
                    style={{
                      marginBottom: "0",
                      color: "#5c727d",
                      lineHeight: "1.8",
                    }}
                  >
                    {maintenanceGalleryText}
                  </p>
                </div>

                <div className="row g-4 mb-4">
                  {maintenancePageImages.slice(1).map((image, index) => {
                    const imageCaptions = [galleryCaptionOne, galleryCaptionTwo];

                    return (
                      <div className="col-md-6" key={image}>
                        <div style={imageCardStyle}>
                          <img
                            src={image}
                            alt={`${copy.imageLabel} ${index + 2}`}
                            style={{
                              width: "100%",
                              height: "290px",
                              objectFit: "cover",
                              display: "block",
                            }}
                          />
                          <div
                            style={{
                              padding: "16px 18px 18px",
                              background: "#fffdfa",
                              borderTop: "1px solid rgba(187, 165, 92, 0.12)",
                            }}
                          >
                            <div
                              style={{
                                display: "inline-block",
                                fontSize: "11px",
                                fontWeight: "700",
                                letterSpacing: "0.05em",
                                textTransform: "uppercase",
                                color: "#bba55c",
                                marginBottom: "6px",
                              }}
                            >
                              {copy.imageLabel}
                            </div>
                            <p
                              style={{
                                margin: 0,
                                color: "#1f2937",
                                fontWeight: 600,
                                lineHeight: 1.6,
                              }}
                            >
                              {imageCaptions[index] || copy.imageLabel}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <h4 className="title-2 mt-4">{servicesHeading}</h4>

                {Array.isArray(copy.serviceMatrix) && copy.serviceMatrix.length > 0 ? (
                  <div className="qtech-service-matrix">
                    <div className="qtech-service-matrix__header">
                      <span>{matrixHeaderService}</span>
                      <span>{matrixHeaderDetails}</span>
                    </div>
                    {copy.serviceMatrix.map((row, index) => (
                      <div className="qtech-service-matrix__row" key={row.service || index}>
                        <div className="qtech-service-matrix__service">{row.service}</div>
                        <div className="qtech-service-matrix__details">{row.details}</div>
                      </div>
                    ))}
                  </div>
                ) : null}

                <h4 className="title-2 mt-4">{methodologyHeading}</h4>

                <div className="qtech-service-highlight-list">
                  {methodologyCards.map((item, index) => (
                    <div className="qtech-service-highlight-card" key={item.title || index}>
                      <h5>{item.title}</h5>
                      <p>{item.body}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    {sidebar.map((item) => (
                      <li
                        key={item.to}
                        className={
                          item.to === "/property-maintenance-operations-saudi-arabia" ? "active" : ""
                        }
                      >
                        <Link to={item.to}>
                          {item.label}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <ServiceInquiryForm
                  serviceTitle={copy.title}
                  serviceSlug="property-maintenance-operations-saudi-arabia"
                />
                <div className="widget ltn__banner-widget">
                  <a href="/shop.html">
                    <img
                      src={maintenanceSidebarImage}
                      alt={copy.imageLabel}
                      style={{ width: "100%", minHeight: "320px", objectFit: "cover" }}
                    />
                  </a>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceAndOperation;
